export const SEARCH_PLACEHOLDER = 'Chat.Reply.Select.Search'
